import React, { useEffect, useState } from "react";
import SideBarComponent from "../components/SideBarComponent";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { getUserDetails, postUserDetails } from "../store/actions";

const SideBarContainer = ({
  addNewButtonClicked,
  onClose,
  editUser,
  handleSave,
  formData,
  handleInputChange,
  masterData,
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        handleSave();
      }
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formData]);
  return (
    <>
      <SideBarComponent
        addNewButtonClicked={addNewButtonClicked}
        editUser={editUser}
        onClose={onClose}
        formData={formData}
        handleSave={handleSave}
        handleInputChange={handleInputChange}
        masterData={masterData}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default SideBarContainer;
